import { render, staticRenderFns } from "./NbBadge.vue?vue&type=template&id=1f8a660f&scoped=true&"
import script from "./NbBadge.vue?vue&type=script&lang=js&"
export * from "./NbBadge.vue?vue&type=script&lang=js&"
import style0 from "./NbBadge.vue?vue&type=style&index=0&id=1f8a660f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8a660f",
  null
  
)

export default component.exports